import { api } from '../../../servicesGlobais/api'
import {
  AtualizarJobScheduleDto,
  JobDefinicao,
  JobExecucaoHistorico,
  JobExecutarResposta,
} from '../tipos/job'

export const jobsService = {
  async listar(): Promise<JobDefinicao[]> {
    const list = await api.get<JobDefinicao[]>('/JobDefinicao')
    return Array.isArray(list) ? list : []
  },

  async obter(id: number): Promise<JobDefinicao> {
    return await api.get<JobDefinicao>(`/JobDefinicao/${id}`)
  },

  async atualizarSchedule(id: number, data: AtualizarJobScheduleDto): Promise<JobDefinicao> {
    return await api.put<JobDefinicao>(`/JobDefinicao/${id}`, data)
  },

  async alternarAtivo(id: number, ativo: boolean): Promise<JobDefinicao> {
    return await api.patch<JobDefinicao>(`/JobDefinicao/${id}/ativo`, { ativo })
  },

  async executarAgora(id: number): Promise<JobExecutarResposta> {
    return await api.post<JobExecutarResposta>(`/JobDefinicao/${id}/executar`)
  },

  async obterHistorico(id: number, take = 20): Promise<JobExecucaoHistorico[]> {
    const list = await api.get<JobExecucaoHistorico[]>(`/JobDefinicao/${id}/historico?take=${take}`)
    return Array.isArray(list) ? list : []
  },
}
